import { Sparkles, Lightbulb, Palette, Maximize, Volume2, ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TheGrandBallroom() {
  const recoveryDetails = [{
    icon: Lightbulb,
    title: "Custom Lighting",
    desc: "Bespoke chandeliers and programmable LED systems create the perfect mood for your evening."
  }, {
    icon: Palette,
    title: "Contemporary Décor",
    desc: "A minimalist architectural canvas designed to complement any floral or design aesthetic."
  }, {
    icon: Maximize,
    title: "Versatile Layouts",
    desc: "Flexible floor plans accommodating up to 300 guests with seamless flow and visibility."
  }, {
    icon: Volume2,
    title: "Acoustic Excellence",
    desc: "State-of-the-art sound engineering ensures crystal clear speeches and immersive music."
  }];
  return <section data-section-id="253656" id="the-grand-ballroom" className="relative w-full py-24 md:py-32 bg-background overflow-hidden dark">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683483/img/grand_ballroom_windows.png)]" />
        {}
        <div className="absolute inset-0 bg-background/60 md:bg-transparent" />
      </div>

      {}
      <div className="container mx-auto px-6 relative z-10 max-w-7xl flex flex-col md:flex-row md:justify-end items-center">
        <Card className="w-full max-w-2xl bg-card/90 backdrop-blur-md shadow-2xl border-border/20 p-8 md:p-12 rounded-md">
          <CardContent className="p-0 flex flex-col gap-8">
            {}
            <div>
              <div className="w-16 h-16 rounded-md bg-primary/10 flex items-center justify-center mb-6 shadow-sm">
                <Sparkles className="w-8 h-8 text-primary" />
              </div>
              <h2 className="text-3xl md:text-5xl font-medium font-default text-foreground mb-4 tracking-tight">
                The Grand Ballroom
              </h2>
              <div className="w-16 h-0.5 bg-primary mb-6" />
              <p className="text-muted-foreground font-default text-xl leading-relaxed">
                Experience the pinnacle of modern elegance. Our ballroom features floor-to-ceiling windows that bathe the space in natural light, transitioning into a sophisticated evening sanctuary.
              </p>
            </div>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-10">
              {recoveryDetails.map((item, i) => <div key={i} data-index={i} className="flex flex-col gap-3">
                  <div className="flex items-center gap-3">
                    <div className="p-2 rounded-md bg-primary/5">
                      <item.icon className="w-5 h-5 text-primary" />
                    </div>
                    <h3 className="font-medium font-default text-foreground text-lg tracking-wide">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-sm text-muted-foreground font-sans leading-relaxed">
                    {item.desc}
                  </p>
                </div>)}
            </div>

            {}
            <div className="pt-4 border-t border-border/30 mt-2">
              <Button asChild size="lg" className="w-full sm:w-auto group bg-primary text-primary-foreground rounded-md font-mono uppercase tracking-widest text-xs">
                <Link to="/EstatePage">
                  Explore The Estate
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>;
}